import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 18,
	viewBox: "0 0 40 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: 2.5,
			width: 39,
			height: 15,
			rx: 1.5,
			fill: "black",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 39,
			height: 15,
			rx: 1.5,
			fill: "white",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 4.5,
			y1: 5.5,
			x2: 35.5,
			y2: 5.5,
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 4.5,
			y1: 10.5,
			x2: 35.5,
			y2: 10.5,
			stroke: "black",
			strokeLinecap: "round"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20width%3D%2240%22%20height%3D%2218%22%20viewBox%3D%220%200%2040%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%220.5%22%20y%3D%222.5%22%20width%3D%2239%22%20height%3D%2215%22%20rx%3D%221.5%22%20fill%3D%22black%22%20stroke%3D%22black%22%2F%3E%3Crect%20x%3D%220.5%22%20y%3D%220.5%22%20width%3D%2239%22%20height%3D%2215%22%20rx%3D%221.5%22%20fill%3D%22white%22%20stroke%3D%22black%22%2F%3E%3Cline%20x1%3D%224.5%22%20y1%3D%225.5%22%20x2%3D%2235.5%22%20y2%3D%225.5%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%2F%3E%3Cline%20x1%3D%224.5%22%20y1%3D%2210.5%22%20x2%3D%2235.5%22%20y2%3D%2210.5%22%20stroke%3D%22black%22%20stroke-linecap%3D%22round%22%2F%3E%3C%2Fsvg%3E%0A";
